import React, { Component } from 'react'

export default class PopoverItem extends Component {
  render() {
    let { slotEventsDetail } = this.props;

    slotEventsDetail.map((emp, idx) => {
        console.log(emp)
    })

    return (
        <div>
            <ul className="list-group">
                {slotEventsDetail.length > 0 &&
                    slotEventsDetail.map((emp, idx) => (
                        <li
                            className="list-group-item popoverbackground"
                            key={idx}
                        >
                            {`${emp.EmployeeFirstName} ${emp.EmployeeLastName}`}
                        </li>
                    ))}
            </ul>
        </div>
    )
  }
}
